import { rootApi } from "../../api/rootApi";

export const userPermissionsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllUserPermissions: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/userPermissions`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    getAllUnverifiedProfiles: builder.mutation({
      query: (params) => {
        let url = `/tenant/userPermission/get-all-unverified-profiles?limit=${params.limit || 10}&offset=${params.offset || 0}`;
        if (params.search) url += `&search=${params.search}`;
        if (params.dateFrom) url += `&dateFrom=${params.dateFrom}`;
        if (params.dateTo) url += `&dateTo=${params.dateTo}`;

        return {
          method: "GET",
          url: url,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    getAllApprovalList: builder.mutation({
      query: (params) => {
        let url = `/tenant/userPermission/get-all-approval-list?limit=${params.limit || 10}&offset=${params.offset || 0}`;
        if (params.search) url += `&search=${params.search}`;
        if (params.dateFrom) url += `&dateFrom=${params.dateFrom}`;
        if (params.dateTo) url += `&dateTo=${params.dateTo}`;

        return {
          method: "GET",
          url: url,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    setUserApprover: builder.mutation({
      query: (params) => {
        console.log("::::::::", params.data)
        return {
          method: "POST",
          url: `/tenant/userPermission/set-user-approver`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
    getPerUserApprovalList: builder.mutation({
      query: (params) => {
        let url = `/tenant/userPermission/per-user-approval-list?limit=${params.limit || 10}&offset=${params.offset || 0}`;
        if (params.search) url += `&search=${params.search}`;
        if (params.dateFrom) url += `&dateFrom=${params.dateFrom}`;
        if (params.dateTo) url += `&dateTo=${params.dateTo}`;

        return {
          method: "GET",
          url: url,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    approveLotusUser: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/userPermission/approve-lotus-user`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
    getSupportIssues: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/userPermission/get-support-issues`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    resolveSupportIssue: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/userPermission/resolve-support-issue`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
    deleteLotusUser: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/userPermission/delete-lotus-user`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
  }),
});

export const {
  useGetAllUserPermissionsMutation,
  useGetAllUnverifiedProfilesMutation,
  useGetAllApprovalListMutation,
  useSetUserApproverMutation,
  useGetPerUserApprovalListMutation,
  useApproveLotusUserMutation,
  useGetSupportIssuesMutation,
  useResolveSupportIssueMutation,
  useDeleteLotusUserMutation,
} = userPermissionsApi;
